"use strict";
/* eslint-disable import/no-cycle */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = exports.changeI18nLanguage = exports.initI18n = void 0;
// @copyright 2023 MXM, Inc
var i18next_1 = __importDefault(require("i18next"));
var i18next_chained_backend_1 = __importDefault(require("i18next-chained-backend"));
var i18next_resources_to_backend_1 = __importDefault(require("i18next-resources-to-backend"));
var config_1 = require("../config");
var events_1 = require("../events");
/**
 * initializes i18n module by wrapping the i18next module
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var initI18n = function (language, callback) {
    var resources = {
        en: {},
        es: {},
        uk: {},
    };
    i18next_1.default.use(i18next_chained_backend_1.default).init({
        compatibilityJSON: 'v3',
        lng: language,
        fallbackLng: 'en',
        debug: (0, config_1.getConfig)().logging,
        ns: [],
        defaultNS: 'common',
        fallbackNS: 'common',
        backend: {
            backends: [(0, i18next_resources_to_backend_1.default)(resources)],
            backendOptions: [],
            // loadPath: 'https://raw.githubusercontent.com/rvegas/i18next-test-txns/master/{{lng}}/{{ns}}.json',
            // crossDomain: true
        },
    });
};
exports.initI18n = initI18n;
var changeI18nLanguage = function (language, callback) {
    i18next_1.default.changeLanguage(language, function () {
        (0, events_1.publish)('mxm.i18n', 'change_language.success');
        if (callback) {
            callback();
        }
    });
    i18next_1.default.reloadResources(language);
};
exports.changeI18nLanguage = changeI18nLanguage;
/**
 * Translates a string using a wrapper of the i18next module
 * @param key The key of the string to translate (e.g. 'login.title') - We could look into adding more params such as
 * 'view' or 'component' instead of leaving it up to the app or web's developer to decide
 * @param params allows embedding variables in the string
 */
var t = function (key, params) { return i18next_1.default.t(key, params); };
exports.t = t;
